<template>
	<main>
		<HeaderTab :title="getTrad('monte.contract_list')"  :return_action="'navigationBack'"/>
		<div id="content">
			<shutter-panel ref="shutterPanel" />
		</div>
	</main>
</template>

<script type="text/javascript">
import Shutter from "@/mixins/Shutter.js"
import ShutterContract from "@/mixins/shutters-manager/Contract.js"

export default {
	name: 'Contract',
	mixins: [Shutter, ShutterContract],
	data () {
		return {}
	},

	mounted() {
		this.init_component()
	},

	beforeDestroy() {
		// Fermer tous les shutters pour éviter les fuites mémoire
		if (this.$refs.shutterPanel) {
			const panel = this.$refs.shutterPanel
			if (panel.orderedShutters) {
				panel.orderedShutters.forEach(s => {
					panel.close(s.name)
				})
			}
		}
	},

	watch: {
		'$route'(to, from) {
			if (to.name !== from.name) {
				if (this.$refs.shutterPanel) {
					const panel = this.$refs.shutterPanel
					if (panel.orderedShutters) {
						panel.orderedShutters.forEach(s => panel.close(s.name))
					}
				}
				this.init_component()
			}
		}
	},

	methods: {
		init_component() {
			if(this.$route.name === 'ContractListOnline')
				this.setupContractListOnline()
			else
				this.setupContractList()
		}
	},

	components: {
		HeaderTab: () => import('@/components/HeaderTab')
	}
};

</script>